import { InjectionToken } from "@angular/core";
import { environment } from "../environments/environment";

export * from "@root/common/links";
// --------------------------
// ---------全局常量----------
// --------------------------

export const VERSION = environment.version;

/** 分享微店的url */
export const URL_CONFIG = {
  h5_shop_url: environment.h5_shop_url,
  web_url: environment.web_url,
};

export enum ErrorCode {
  Success = 0,
  // USER_IN_REVIEW = 200000,
  // INVALID_PHONE_NUMBER = 200004,
  AuthFailed = 210001,
  AccountOccupied = 214000,
  USER_NEED_FINISH_INFO = 210002,
  IncorrectImageCode = 220000,
  // NO_AUTHORITY = 220001,
  // USER_ALREADY_REGISTE = 200003,
  NeedImageCode = 200001,
  NeedEmailVerification = 200008,
  // CODE_SYNCER_HOUSE_FAILED = 211000,
  // CODE_THIRDPARTY_LOGIN_FAIL = 213000,
  AIRBNB_NEED_VERIFICATION_FOR_LOGIN = 213001,
  CTRIP_NEED_VERIFICATION_FOR_LOGIN = 213003,
  ZHENGUO_NEED_VERIFICATION_FOR_LOGIN = 213004,
  AIRBNB_NEED_GEETEST_VERIFY_FOR_LOGIN = 213005,
  VRBO_NEED_VERIFICATION_FOR_LOGIN = 213006,
  MEITUAN_NEED_VERIFICATION_FOR_LOGIN = 213007,
  DouyinNeedSliderVerify = 213008,
  CODE_OPERATOR_MESSAGE_NOT_FOUND = 240000,
  CODE_NO_USER_WHEN_RESET_PASSWORD = 400002,
  CODE_WRONG_WHEN_RESET_PASSWORD = 400001,
  CODE_IMAGE_CODE_WRONG_WHEN_RESET_PASSWORD = 400000,
  PlanExpired = 60000,
}

export enum PlatformType {
  Airbnb = 0,
  TuJia = 1,
  XiaoZhu = 2,
  YiJia = 3,
  MaYi = 4,
  DirectBooking = 5, // 手工订单
  Shop = 6,
  MeiTuanMinSu = 7, // 美团民宿/榛果
  MuNiao = 8,
  Booking = 9,
  TuJiaGYS = 10,
  Ctrip = 11, // 携程 账号密码登录
  MeiTuanJiuDian = 12, // 美团酒店
  Fliggy = 13, // 飞猪
  ZhuDuoDuo = 14, // 住多多
  HomeAway = 15, // homeway
  Agoda = 16, // agoda
  Expedia = 17,
  Asiayo = 18,
  Waka = 19,
  Vrbo = 20,
  ZhuKeYun = 21, // 住客云
  XHS = 23,
  Douyin = 22,
  Bookingsite = 24,
  CtripOffical = 25, // 携程官方直连
  TuJiaIntl = 26, // 途家国际
  GoogleVR = 27,
  Houfy = 28,
  TongCheng = 29,
}

export interface IPlatform {
  type: PlatformType;
  name: string;
  icon: string;
  icon_color: string;

  // icon_gray: string;
  [propName: string]: any;
}

export const PlatformInfo: Record<PlatformType, IPlatform> = {
  [PlatformType.Airbnb]: {
    type: PlatformType.Airbnb,
    name: "爱彼迎",
    // icon: "/assets/new_icon/airbnb.png",
    // icon_color: "/assets/new_icon/airbnb_color.png",
    // icon_gray: "/assets/new_icon/airbnb_gray.png",

    icon: "/assets/v4/icon-airbnb.svg",
    icon_border: "/assets/v4/icon-airbnb-border.svg",
    icon_color: "/assets/v4/icon-airbnb-color.png",
    icon_color_bg: "/assets/v4/icon-airbnb-color-bg.svg",
    icon_large: "/assets/v4/icon-airbnb-large.svg",
    icon_large_en: "/assets/v4/icon-airbnb-large.svg",
    signalColor: "#ff6661",

    show: true,
    intlShow: true,
    order: 12,
    intlOrder: 1,
    desc: "官方直连 | 渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PlatformType.TuJia]: {
    type: PlatformType.TuJia,
    name: "途家",
    // icon: "/assets/new_icon/tujia.png",
    // icon_color: "/assets/new_icon/tujia_color.png",
    // icon_gray: "/assets/new_icon/tujia_gray.png",

    icon: "/assets/v4/icon-tujia.svg",
    icon_border: "/assets/v4/icon-tujia-border.svg",
    icon_color: "/assets/v4/icon-tujia-color.png",
    icon_color_bg: "/assets/v4/icon-tujia-color-bg.svg",
    icon_large: "/assets/v4/icon-tujia-large.svg",
    icon_large_en: "/assets/v4/icon-tujia-large.svg",
    signalColor: "#ed6d01",

    show: true,
    intlShow: false,
    order: 2,
    desc: "直连模式 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PlatformType.XiaoZhu]: {
    type: PlatformType.XiaoZhu,
    name: "小猪短租",
    // icon: "/assets/new_icon/xiaozhu_new.png",
    // icon_color: "/assets/new_icon/xiaozhu_new_color.png",
    // icon_gray: "/assets/new_icon/xiaozhu_new_gray.png",

    icon: "/assets/v4/icon-xiaozhu.svg",
    icon_border: "/assets/v4/icon-xiaozhu-border.svg",
    icon_color: "/assets/v4/icon-xiaozhu-color.svg",
    icon_color_bg: "/assets/v4/icon-xiaozhu-color-bg.svg",
    icon_large: "/assets/v4/icon-xiaozhu-large.svg",
    icon_large_en: "https://oss.image.xiaogetech.com/FEU1684487647927.png",
    signalColor: "#ff5e79",

    show: true,
    intlShow: true,
    order: 4,
    intlOrder: 6,
    desc: "直连模式 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PlatformType.YiJia]: {
    type: PlatformType.YiJia,
    name: "一家民宿",
    icon_color_bg: "/assets/new_icon/yijia.png",
    icon_color: "/assets/new_icon/yijia_color.png",
    icon_large: "/assets/new_icon/yijia_color.png",
    icon_large_en: "/assets/new_icon/yijia_color.png",
    icon: "/assets/new_icon/yijia_gray.png",
    signalColor: "#ff5e79",

    show: true,
    intlShow: false,
    order: 8,
    desc: "直连模式 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PlatformType.MaYi]: {
    type: PlatformType.MaYi,
    name: "蚂蚁",
    icon_color_bg: "/assets/new_icon/yijia.png",
    icon_color: "/assets/new_icon/yijia_color.png",
    icon: "/assets/new_icon/yijia_gray.png",

    show: false,
    intlShow: false,
    order: 10,
    desc: "直连模式 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PlatformType.DirectBooking]: {
    type: PlatformType.DirectBooking,
    name: "百居易",
    icon: "/assets/icon/icon_default_platform.png",
    icon_color: "/assets/icon/icon_default_platform.png",
    icon_color_bg: "/assets/icon/icon_default_platform.png",
    icon_gray: "/assets/icon/icon_default_platform.png",
    show: false,
    intlShow: false,
    order: 100,
    desc: "",
  },
  [PlatformType.Shop]: {
    type: PlatformType.Shop,
    name: "民宿微店",
    // icon: '/assets/icon/icon_shop.svg',
    icon: "/assets/v4/icon-hostex-color.svg",
    // icon_color: '/assets/icon/icon_shop_color.svg',
    icon_color: "/assets/v4/icon-hostex-color.svg",
    icon_color_bg: "/assets/v4/icon-hostex-color.svg",
    icon_gray: "/assets/v4/icon-hostex-color.svg",
    show: true,
    intlShow: false,
    order: 10,
    desc: "房东自有渠道 | 免佣金支出 | 以小程序、H5展示给房客 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PlatformType.MeiTuanMinSu]: {
    type: PlatformType.MeiTuanMinSu,
    name: "美团民宿",
    // icon: "/assets/new_icon/zhenguo.png",
    // icon_color: "/assets/new_icon/zhenguo_color.png",
    // icon_gray: "/assets/new_icon/zhenguo_gray.png",

    icon: "/assets/v4/icon-zhenguo.svg",
    icon_border: "/assets/v4/icon-zhenguo-border.svg",
    icon_color: "/assets/v4/icon-zhenguo-color.svg",
    icon_color_bg: "/assets/v4/icon-zhenguo-color-bg.svg",
    icon_large: "/assets/v4/icon-zhenguo-large.svg",
    icon_large_en: "/assets/v4/icon-zhenguo-large.svg",
    signalColor: "#ffcf02",

    show: true,
    intlShow: false,
    order: 1,
    desc: "官方直连 | 房态房价管理 | 订单管理 | 聊天管理（账号密码登录）",
  },
  [PlatformType.MuNiao]: {
    type: PlatformType.MuNiao,
    name: "木鸟短租",
    // icon: "/assets/new_icon/muniao.png",
    // icon_color: "/assets/new_icon/muniao_color.png",
    // icon_gray: "/assets/new_icon/muniao_gray.png",

    icon: "/assets/v4/icon-muniao.svg",
    icon_border: "/assets/v4/icon-muniao-border.svg",
    icon_color: "/assets/v4/icon-muniao-color.svg",
    icon_color_bg: "/assets/v4/icon-muniao-color-bg.svg",
    icon_large: "/assets/v4/icon-muniao-large.svg",
    icon_large_en: "https://oss.image.xiaogetech.com/EUC1684487647930.png",
    signalColor: "#fe603d",

    show: true,
    intlShow: true,
    order: 3,
    intlOrder: 7,
    desc: "直连模式 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PlatformType.Booking]: {
    type: PlatformType.Booking,
    name: "缤客Booking",
    // icon: "/assets/new_icon/booking.png",
    // icon_color: "/assets/new_icon/booking_color.png",
    // icon_gray: "/assets/new_icon/booking_gray.png",

    icon: "/assets/v4/icon-booking.svg",
    icon_border: "/assets/v4/icon-booking-border.svg",
    icon_color: "/assets/v4/icon-booking-color.png",
    icon_color_bg: "/assets/v4/icon-booking-color-bg.svg",
    icon_large: "/assets/v4/icon-booking-large.svg",
    icon_large_en: "/assets/v4/icon-booking-large.svg",
    signalColor: "#23377b",

    show: true,
    intlShow: true,
    order: 9,
    intlOrder: 2,
    desc: "订单同步 | 自动关房 | 房态房价管理",
  },
  [PlatformType.TuJiaGYS]: {
    type: PlatformType.TuJiaGYS,
    name: "途家供应商",
    icon_color_bg: "/assets/new_icon/tujiaGYS.png",
    icon_color: "/assets/new_icon/tujiaGYS_color.png",
    icon: "/assets/new_icon/tujiaGYS_gray.png",
    show: true,
    intlShow: false,
    order: 10,
    desc: "途家官方直连 | 无需途家账号即可快速发布房源至途家 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PlatformType.Ctrip]: {
    type: PlatformType.Ctrip,
    name: "携程",
    // icon: "/assets/new_icon/ctrip.png",
    // icon_color: "/assets/new_icon/ctrip_color.png",
    // icon_gray: "/assets/new_icon/ctrip_gray.png",

    icon: "/assets/v4/icon-ctrip.svg",
    icon_border: "/assets/v4/icon-ctrip-border.svg",
    icon_color: "/assets/v4/icon-ctrip-color.svg",
    icon_color_bg: "/assets/v4/icon-ctrip-color-bg.svg",
    icon_large: "/assets/v4/icon-ctrip-large.svg",
    icon_large_en: "https://oss.image.xiaogetech.com/FNK1684487647918.png",
    signalColor: "#2576e2",

    show: true,
    intlShow: true,
    order: 5,
    intlOrder: 5,
    desc: "订单同步 | 自动关房 | 房态房价管理",
  },
  [PlatformType.MeiTuanJiuDian]: {
    type: PlatformType.MeiTuanJiuDian,
    name: "美团",
    // icon: "/assets/new_icon/meituan.png",
    // icon_color: "/assets/new_icon/meituan_color.png",
    // icon_gray: "/assets/new_icon/meituan_gray.png",

    icon: "/assets/v4/icon-meituan.svg",
    icon_border: "/assets/v4/icon-meituan-border.svg",
    icon_color: "/assets/v4/icon-meituan-color.svg",
    icon_color_bg: "/assets/v4/icon-meituan-color-bg.svg",
    icon_large: "/assets/v4/icon-meituan-large.svg",
    icon_large_en: "/assets/v4/icon-meituan-large.svg",
    signalColor: "#ffd200",

    show: true, // 测试环境
    // show: false, // 上线环境
    intlShow: false,
    order: 6,
    desc: "官方直连 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PlatformType.Fliggy]: {
    type: PlatformType.Fliggy,
    name: "飞猪",
    // icon: "/assets/new_icon/fliggy.png",
    // icon_color: "/assets/new_icon/fliggy_color.png",
    // icon_gray: "/assets/new_icon/fliggy_gray.png",

    icon: "/assets/v4/icon-fliggy.svg",
    icon_border: "/assets/v4/icon-fliggy-border.svg",
    icon_color: "/assets/v4/icon-fliggy-color.svg",
    icon_color_bg: "/assets/v4/icon-fliggy-color-bg.svg",
    icon_large: "/assets/v4/icon-fliggy-large.svg",
    icon_large_en: "/assets/v4/icon-fliggy-large.svg",
    signalColor: "#ebb408",

    show: true,
    intlShow: false,
    order: 10,
    desc: "订单同步 | 自动关房 | 房态房价管理",
  },
  [PlatformType.ZhuDuoDuo]: {
    type: PlatformType.ZhuDuoDuo,
    name: "住多多",
    icon_color_bg: "/assets/new_icon/zhuduoduo.png",
    icon_color: "/assets/new_icon/zhuduoduo_color.png",
    icon: "/assets/new_icon/zhuduoduo_gray.png",
    // show: true, // 测试环境
    show: false, // 上线环境
    intlShow: false,
    order: 10,
    desc: "途家官方直连 | 无需途家账号即可快速发布房源至途家 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PlatformType.HomeAway]: {
    type: PlatformType.HomeAway,
    name: "HomeAway/Vrbo",
    icon_color_bg: "/assets/new_icon/homeaway.png",
    icon_color: "/assets/new_icon/homeaway_color.png",
    icon: "/assets/new_icon/homeaway_gray.png",
    // show: true, // 测试环境
    show: false, // 上线环境
    intlShow: false,
    order: 10,
    desc: "途家官方直连 | 无需途家账号即可快速发布房源至途家 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PlatformType.Agoda]: {
    type: PlatformType.Agoda,
    name: "Agoda",
    // icon: "/assets/new_icon/agoda.png",
    // icon_color: "/assets/new_icon/agoda_color.png",
    // icon_gray: "/assets/new_icon/agoda_gray.png",

    icon: "/assets/v4/icon-agoda.svg",
    icon_border: "/assets/v4/icon-agoda-border.svg",
    icon_color: "/assets/v4/icon-agoda-color.svg",
    icon_color_bg: "/assets/v4/icon-agoda-color-bg.svg",
    icon_large: "/assets/v4/icon-agoda-large.svg",
    icon_large_en: "/assets/v4/icon-agoda-large.svg",
    signalColor: "#04a9df",

    // show: true, // 测试环境
    show: true, // 上线环境
    intlShow: true,
    order: 11,
    intlOrder: 4,
    desc: "途家官方直连 | 无需途家账号即可快速发布房源至途家 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PlatformType.Expedia]: {
    type: PlatformType.Expedia,
    name: "Expedia",
    icon_color_bg: "/assets/v4/icon-expedia-color-bg.svg",
    icon_color: "/assets/v4/icon-expedia-color.svg",
    icon: "/assets/v4/icon-expedia.svg",
    // show: true, // 测试环境
    show: false, // 上线环境
    intlShow: false,
    order: 10,
    desc: "途家官方直连 | 无需途家账号即可快速发布房源至途家 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PlatformType.Asiayo]: {
    type: PlatformType.Asiayo,
    name: "AsiaYo",
    icon_color_bg: "/assets/new_icon/asiayo.png",
    icon_color: "/assets/new_icon/asiayo_color.png",
    icon: "/assets/new_icon/asiayo_gray.png",
    // show: true, // 测试环境
    show: false, // 上线环境
    intlShow: false,
    order: 10,
    desc: "途家官方直连 | 无需途家账号即可快速发布房源至途家 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PlatformType.Waka]: {
    type: PlatformType.Waka,
    name: "WaKa",
    icon_color_bg: "/assets/new_icon/waka.png",
    icon_color: "/assets/new_icon/waka_color.png",
    icon: "/assets/new_icon/waka_gray.png",
    // show: true, // 测试环境
    show: false, // 上线环境
    intlShow: false,
    order: 10,
    desc: "途家官方直连 | 无需途家账号即可快速发布房源至途家 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PlatformType.Vrbo]: {
    type: PlatformType.Vrbo,
    name: "Vrbo",
    // icon: "/assets/new_icon/vrbo_color.png",
    // icon_color: "/assets/new_icon/vrbo_color.png",
    // icon_gray: "/assets/new_icon/vrbo_color.png",

    icon: "/assets/v4/icon-vrbo.svg",
    icon_border: "/assets/v4/icon-vrbo-border.svg",
    icon_color: "/assets/v4/icon-vrbo-color.svg",
    icon_color_bg: "/assets/v4/icon-vrbo-color-bg.svg",
    icon_large: "/assets/v4/icon-vrbo-large.svg",
    icon_large_en: "/assets/v4/icon-vrbo-large.svg",
    signalColor: "#5B83D3",

    order: 15,
    intlOrder: 3,
    show: false,
    intlShow: true,
  },
  [PlatformType.ZhuKeYun]: {
    type: PlatformType.ZhuKeYun,
    name: "高级微店（住客云）",
    icon: "/assets/new_icon/zhukeyun.png",
    icon_color: "/assets/new_icon/zhukeyun_color.png",
    icon_color_bg: "/assets/new_icon/zhukeyun_color.png",
    icon_gray: "/assets/new_icon/zhukeyun_gray.png",
    show: true,
    desc: "房东自有渠道 | 支持渠道管理 | 房态房价管理 | 订单管理 | 聊天管理",
  },
  [PlatformType.XHS]: {
    type: PlatformType.XHS,
    name: "小红书",
    icon: "https://oss.image.xiaogetech.com/UCG1683887470520.png",
    icon_color: "https://oss.image.xiaogetech.com/CLH1683887470635.png",
    icon_color_bg: "https://oss.image.xiaogetech.com/OSH1683887470542.png",
    icon_gray: "https://oss.image.xiaogetech.com/VPY1683887470523.png",
    icon_large: "https://oss.image.xiaogetech.com/ARS1684205413875.png",
    icon_large_en: "https://oss.image.xiaogetech.com/ARS1684205413875.png",
    signalColor: "#ff213b",
    show: true,
    intlShow: false,
    order: 7,
  },
  [PlatformType.Douyin]: {
    type: PlatformType.Douyin,
    name: "抖音",
    icon: "https://oss.image.xiaogetech.com/MEC1683887470543.png",
    icon_color: "https://oss.image.xiaogetech.com/PAD1683887470524.png",
    icon_color_bg: "https://oss.image.xiaogetech.com/FHO1683887470636.png",
    icon_gray: "https://oss.image.xiaogetech.com/MEC1683887470543.png",
    icon_large: "https://oss.image.xiaogetech.com/SJJ1684205413875.png",
    icon_large_en: "https://oss.image.xiaogetech.com/SJJ1684205413875.png",
    signalColor: "#121212",
    show: true,
    intlShow: false,
    order: 8,
  },
  [PlatformType.Bookingsite]: {
    type: PlatformType.Bookingsite,
    name: "bookingsite",
    show: false,
    intlShow: false,
    icon: "/assets/v4/icon-bookingsite.svg",
    // icon_color: '/assets/icon/icon_shop_color.svg',
    icon_color: "/assets/v4/icon-bookingsite-color.svg",
    icon_color_bg: "/assets/v4/icon-bookingsite-color-bg.svg",
    icon_gray: "/assets/v4/icon-hostex-color.svg",
  },
  [PlatformType.CtripOffical]: {
    type: PlatformType.CtripOffical,
    name: "携程",
    // icon: "/assets/new_icon/ctrip.png",
    // icon_color: "/assets/new_icon/ctrip_color.png",
    // icon_gray: "/assets/new_icon/ctrip_gray.png",

    icon: "/assets/v4/icon-ctrip.svg",
    icon_border: "/assets/v4/icon-ctrip-border.svg",
    icon_color: "/assets/v4/icon-ctrip-color.svg",
    icon_color_bg: "/assets/v4/icon-ctrip-color-bg.svg",
    icon_large: "/assets/v4/icon-ctripoffical-large.svg",
    icon_large_en: "/assets/v4/icon-ctripoffical-large-en.svg",
    signalColor: "#2576e2",

    show: true,
    intlShow: true,
    order: 5,
    intlOrder: 5,
    desc: "订单同步 | 自动关房 | 房态房价管理",
  },
  [PlatformType.TuJiaIntl]: {
    type: PlatformType.TuJiaIntl,
    name: "途家",
    // icon: "/assets/new_icon/tujia.png",
    // icon_color: "/assets/new_icon/tujia_color.png",
    // icon_gray: "/assets/new_icon/tujia_gray.png",

    icon: "/assets/v4/icon-tujia.svg",
    icon_border: "/assets/v4/icon-tujia-border.svg",
    icon_color: "/assets/v4/icon-tujia-color.svg",
    icon_color_bg: "/assets/v4/icon-tujia-color-bg.svg",
    icon_large: "/assets/v4/icon-tujia-large.svg",
    icon_large_en: "/assets/v4/icon-tujia-large.svg",
    signalColor: "#ed6d01",

    show: true,
    intlShow: false,
    order: 2,
    desc: "",
  },
  [PlatformType.GoogleVR]: {
    type: PlatformType.GoogleVR,
    name: "google vacation rental",
    icon: "/assets/v4/icon-google.svg",
    icon_color: "/assets/v4/icon-google-color.svg",
    icon_color_bg: "/assets/v4/icon-google-color-bg.svg",
  },
  [PlatformType.Houfy]: {
    type: PlatformType.Houfy,
    name: "houfy",
    icon: "/assets/v4/icon-houfy.svg",
    icon_color: "/assets/v4/icon-houfy-color.svg",
    icon_color_bg: "/assets/v4/icon-houfy-color-bg.svg",
  },
  [PlatformType.TongCheng]: {
    type: PlatformType.TongCheng,
    name: "tongcheng",
    icon: "/assets/v4/icon-tongcheng.svg",
    icon_color: "/assets/v4/icon-tongcheng-color.svg",
    icon_color_bg: "/assets/v4/icon-tongcheng-color-bg.svg",
    icon_large: "/assets/v4/icon-tongcheng-large.svg",
  },
};

export enum PaymentPlan {
  Default = 0, // 默认版本
  Standard = 1, // 免费版/标准版
  Professional = 2, // 专业版
  Enterprise = 3, // 企业版
}

/**
 * 权限和路由的映射
 * */
// export const PERMISSION_ROUTE_MAP = {
//   tenant_interaction: ['/app/inbox'],
//   reservation_list: ['/app/reservations'],
//   house_list: ['/app/properties/properties', '/app/properties/room-types'],
//   income_outcome_detail: ['/app/metrics/transactions'],
//   income_outcome_struct: ['/app/metrics/monthly-financials'],
//   business_data: ['/app/metrics/statistics'],
//   shop_manage: ['/app/shop/list'],
//   client_manage: ['/app/guests/list'],
//   automation_message: ['/app/automation/messaging'],
//   automation_comment: ['/app/automation/review'],
//   automation_task: ['/app/automation/task'],
//   automation_price: ['/app/automation/price'],
//   thirdparty: ['/app/connected-accounts/list'],
//   rate: ['/app/price'],
//   calendar: ['/app/calendar'],
//   workbench: ['/app/dashboard'],
//   cleaning_task: ['/app/tasks'],
// };

// --------------------------
// ---------通用函数----------
// --------------------------

//#region 全局配置服务
// export interface AuthConfig {
//   login_url?: string;
// }
// export interface ACLConfig {
//   guard_url?: string;
// }

// export interface IGlobalConfig {
//   auth?: AuthConfig;
//   acl?: ACLConfig;
// }
// export const GLOBAL_CONFIG_TOKEN = new InjectionToken<IGlobalConfig>('GLOBAL_CONFIG_TOKEN');
// export const GlobalConfig: IGlobalConfig = {
//   auth: { login_url: '/app/login' },
// };
//#endregion

//#region 全局通用函数
// log，带颜色输出
export type IColorLog = (message: string, color?: string) => void;
export const LOG_SERVICE_TOKEN = new InjectionToken<IColorLog>("LOG_SERVICE_TOKEN", {
  providedIn: "root",
  factory: () => {
    return (message: string, color = "#2c80f0") => {
      console.log(
        "%c" + message,
        "background-color: #d3d7d4; padding-left: 4px; padding-right: 4px; border-radius: 4px; font-weight: bold; font-size: 12px; color: " +
          color,
      );
    };
  },
});
//#endregion
